
export default {
    setWxConfig(shareConfig){
        wx.config({
            //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: shareConfig.appId, // 必填，公众号的唯一标识
            timestamp: shareConfig.timestamp, // 必填，生成签名的时间戳
            nonceStr: shareConfig.nonceStr, // 必填，生成签名的随机串
            signature: shareConfig.signature,// 必填，签名，见附录1
            jsApiList: ['checkJsApi','updateAppMessageShareData','updateTimelineShareData',
                'onMenuShareTimeline','onMenuShareAppMessage','onMenuShareQQ','onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
    },
    setShare(shareInfo){
        wx.ready(function(){
            console.warn(JSON.stringify(shareInfo));
            wx.updateAppMessageShareData(shareInfo);//“分享给朋友”及“分享到QQ”
            wx.updateTimelineShareData(shareInfo);//”分享到朋友圈”及“分享到QQ空间”
            wx.onMenuShareTimeline(shareInfo);
            wx.onMenuShareAppMessage(shareInfo);
            wx.onMenuShareQQ(shareInfo);
            wx.onMenuShareQZone(shareInfo);
        })
        wx.error(function(res){
            console.warn(res);
        })
        wx.checkJsApi({
            jsApiList: ['updateAppMessageShareData','updateTimelineShareData'
                ,'onMenuShareTimeline','onMenuShareAppMessage','onMenuShareQQ','onMenuShareQZone'],
            success: function(res) {
               console.warn(res)
            }
        })
    }
}